// D-2 SC2: which old clinic-logo files a letterhead save may remove. Pure, so the guard that keeps a storage delete inside
// its lane is unit-tested as shipped (sibling of removableLogoPaths in reports/signature-guard.js, F-7). Delete only after
// the save is confirmed (the caller), never the saved path, never null, only top-level-of-branding logo_<ms>.png|jpg|jpeg
// files in THIS clinic's own branding folder.
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const LOGO_RE = /^logo_[0-9]{1,15}[.](png|jpg|jpeg)$/;

export function logoPathFor(clinicId, ms, mime) {
  return clinicId + '/branding/logo_' + ms + '.' + (mime === 'image/png' ? 'png' : 'jpg');
}

export function removableClinicLogoPaths({ clinicId, saved, candidates }) {
  const out = new Set();
  if (!clinicId || typeof clinicId !== 'string' || !UUID.test(clinicId)) return [];
  const prefix = clinicId + '/branding/';
  for (const p of candidates || []) {
    if (!p || typeof p !== 'string' || p === saved) continue;
    if (!p.startsWith(prefix)) continue;
    if (!LOGO_RE.test(p.slice(prefix.length))) continue;
    out.add(p);
  }
  return [...out];
}
